import React from "react";
import { GridLogos } from "../../Organisms/GridLogos";
export function BlockLogoListing(props) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, props.title ? /*#__PURE__*/ React.createElement("h2", {
        className: "text-center"
    }, props.title) : null, /*#__PURE__*/ React.createElement(GridLogos, {
        logos: props.logos
    }));
}
